module.exports = __webpack_public_path__ + "static/media/billCover.367b5137.jpg";